module.exports = __webpack_public_path__ + "img/WheelLoader.be29b831.png";